type FieldErrorProps = {
  error?: string;
};

export function FieldError({ error }: FieldErrorProps) {
  if (!error) return null;
  return (
    <span className="text-sm text-red-500 dark:text-red-400" role="alert">
      {error}
    </span>
  );
}
